export const routePrefix = '';

export const routes = {
  // authentication routes
  login: `${routePrefix}/login`,
  customerDashboard: `${routePrefix}/customer/dashboard`,
  register: `${routePrefix}/customer/register`,
  forgetPassword: `${routePrefix}/forget-password`,
  trackOrder: `${routePrefix}/track-order`,
  orderDetails: `${routePrefix}/order-details/:id`,

  //unauthentication routes
  home: `${routePrefix}`,
  commonHeader: `${routePrefix}/:header`,
  clothes: `${routePrefix}/clothes`,
  accessories: `${routePrefix}/accessories`,
  food: `${routePrefix}/food`,
  shoes: `${routePrefix}/shoes`,
  category: `${routePrefix}/category/:id`,
  all_category: `${routePrefix}/allcategory`,
  productDetails: `${routePrefix}/product-details/:id`,
  cart: `${routePrefix}/cart`,
  checkout: `${routePrefix}/checkout`,
  pricing: `${routePrefix}/pricing`,
  tableBooking: `${routePrefix}/table-booking`,
  homeEdit: `${routePrefix}/home/edit`,
  home3Edit: `${routePrefix}/home-3/edit`,
  searchResult: `${routePrefix}/search/:value`,
  wareHouseProduct: `${routePrefix}/shop/:id`,
};
